import { ApplicationItem } from "@/types/admin_types";
import { useState } from 'react'
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form"
import * as z from "zod"
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod"
import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "@/context/apiRequest";
import { useAutoCleanError } from "@/hooks/useAutoCleanError";
import Translatable from "@/components/translatable_text/Translatable";
import { Textarea } from "@headlessui/react";
import MsgComponent from "@/components/msg_component/MsgComponent";
import ButtonComponent from "@/components/button/ButtonComponent";

type Props = {
  el: ApplicationItem;
  newStatus: string;
  setOpen: (value: boolean) => void;

}

const formSchema = z.object({
  notes: z.string(),
  status: z.string().min(1, 'Status is required'),
})


export default function ApplicationUpdateURL({ el, newStatus, setOpen }: Props ) {

  const [ error, setError ] = useState('')
  type FormType = z.infer<typeof formSchema>;

  const form = useForm<FormType>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      status: newStatus,
      notes: '',
    },
  })

  const queryClient = useQueryClient()
  const mutation = useMutation({
    mutationFn: (values: object) => {
      return api().put(`/api/v1/admin/applications/${el?.id}`, values);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['job-applications']})
      setOpen(false)
    }, 
    onError: (error) => {
      setError(error.message)
    }
  })

  const handleSubmit = (values: FormType) => {
    const res = mutation.mutateAsync(values)
    console.log(res)
  }

  useAutoCleanError(error, setError)

  return (
    <div>
      <Form {...form}>
        <form
          onSubmit={form.handleSubmit(handleSubmit)}
          className="space-y-2 mt-5"
        >
          <div className='flex flex-col md:flex-row flex-wrap w-full gap-5'>
            <div className="w-full flex flex-col md:flex-row gap-5">

              <div className='w-full '>
                <FormField
                  control={form.control}
                  name="notes"
                  render={({ field }) => (
                    <FormItem>
                    <FormLabel>
                      <Translatable>
                        Note
                      </Translatable>
                    </FormLabel>
                      <FormControl>
                        <Textarea
                        className='rounded border p-2'
                        rows={3}
                          placeholder="Write your notes here ..."
                          {...field}
                          />
                      </FormControl>
                      <FormMessage/> 
                    </FormItem>
                  )}
                />
              </div>
            </div>
            <MsgComponent className='flex items-center justify-center text-rose-700 p-4' message={error}/>
            <ButtonComponent
              title={newStatus === 'approved' ? "Accept" : "Reject"}
              className={`w-full mt-5 bg-purple ${newStatus === 'approved' ? "hover:bg-blue-900" : 'hover:bg-rose-900'}`}
              isSubmitting={mutation.isPending}
              type="submit"
              // variant={}
            />
          </div>
        </form>
      </Form>
    </div>
  )
}
